import axios from "./axios";

class AdminRepository {
  get() {
    return axios.get(`/admin`).then((response) => {
      return response.data;
    });
  }

  clearCache() {
    return axios.get(`/admin/clearCache`).then((response) => {
      return response.data;
    });
  }

  getGames(sport) {
    return axios.get(`/admin/odds/${sport}`).then((response) => {
      return response.data;
    });
  }
}

export default new AdminRepository();



// WEBPACK FOOTER //
// ./src/data/admin.repository.js